import { render, staticRenderFns } from "./WarehouseDetail.vue?vue&type=template&id=0976be60&scoped=true&"
import script from "./WarehouseDetail.vue?vue&type=script&lang=js&"
export * from "./WarehouseDetail.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseDetail.vue?vue&type=style&index=0&id=0976be60&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0976be60",
  null
  
)

export default component.exports